import type React from 'react';
import type {
  BasicContentBlockA,
  BasicContentLayout,
} from '@course-authoring/shared-types';

import { BasicContentBlockEditor } from './BasicContentBlockEditor';

export interface BasicContentBlockAEditorProps {
  block: BasicContentBlockA;
  onChange: (updates: Partial<BasicContentBlockA>) => void;
  onSetLayout: (layout: BasicContentLayout) => void;
  autoFocus?: boolean;
  translationMode?: boolean;
}

export function BasicContentBlockAEditor({
  block,
  onChange,
  onSetLayout,
  autoFocus = false,
  translationMode = false,
}: BasicContentBlockAEditorProps): React.ReactElement {
  return (
    <BasicContentBlockEditor
      block={block}
      onChange={(updates) => onChange(updates as Partial<BasicContentBlockA>)}
      onSetLayout={onSetLayout}
      autoFocus={autoFocus}
      translationMode={translationMode}
    />
  );
}

BasicContentBlockAEditor.displayName = 'BasicContentBlockAEditor';
